export const sxStyle = {
  footerSectionsContainer2: {
    display: 'flex',
    alignItems: { xs: 'center', lg: 'flex-end' },
    justifyContent: { xs: 'center', lg: 'flex-end' },
    mb: { xs: 3, lg: 0 },
  },

  externalLinks: {
    display: 'flex',
    flexDirection: { xs: 'row', lg: 'column' },
    alignItems: 'center',
    justifyContent: { xs: 'center', lg: 'flex-end' },
    gap: { xs: 3, lg: 2 },
    width: 'auto',
  },

  socialMediaContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    flexDirection: 'row',
    gap: { xs: 1.5, md: 2 },
  },

  footer_imgDataFiscal: {
    width: '68px',
    height: '85px',
    opacity: 0.9,
    transition: 'opacity 0.2s',
    '&:hover': { opacity: 1 },
  },

  footer_redesIcono: {
    width: { xs: '26px', md: '26px' },
    height: { xs: '26px', md: '26px' },
    filter: 'brightness(0) invert(1)',
    opacity: 0.8,
    transition: 'opacity 0.2s',
    '&:hover': { opacity: 1 },
  },

  footer_redesIconoLast: {
    width: { xs: '26px', md: '26px' },
    height: { xs: '26px', md: '26px' },
    filter: 'brightness(0) invert(1)',
    opacity: 0.8,
    transition: 'opacity 0.2s',
    '&:hover': { opacity: 1 },
  },
};
